/***
 * 询价管理-发起人搜索
 */

import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { API_POST_BBC_SUPPLIER_GETSHIPPER } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class PriceUser extends React.PureComponent {
  state = {
    users: [],
    loading: false,
  };

  componentDidMount() {
    this.getList();
  }
  // 获取用户
  @Bind()
  @Debounce(1000)
  getList() {
    this.setState({ loading: true, users: [] });
    getData({
      api: API_POST_BBC_SUPPLIER_GETSHIPPER,
      data: {
        pageNo: 1,
        pageSize: 500,
      },
    })
      .then(res => {
        const { data } = res;
        const { getChild } = this.props;

        if (getChild) {
          getChild(data?.data || []);
        }
        this.setState({
          users: data?.data,
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const { users, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        optionFilterProp="children"
        allowClear
        notFoundContent={loading ? <Spin size="small" /> : null}
        showSearch
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {users.map(item => (
          <Select.Option
            title={item.code}
            key={item.code}
            value={renderValue ? renderValue(item) : `${item.code}-${item.name}`}>
            {`${item.code}${item.name}`}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default PriceUser;
